<template>
  <div>
    <b-tabs card>
      <b-tab no-body title="پخش زنده" active class="mt-2">
        <div class="card card-custom gutter-b">
          <div class="card-body">
            <div class="container">
              <div class="row mt-5">
                <div class="form-group col-6">
                  <label>زمان</label>
                  <b-input-group class="mb-3">
                    <b-form-input
                      id="example-input"
                      v-model="time"
                      type="number"
                      placeholder="زمان بر اساس دقیقه"
                    >
                    </b-form-input>
                  </b-input-group>
                </div>
                <div class="form-group col-6">
                  <label>تعداد مقصد ها</label>
                  <b-form-input
                    v-model="destinationNumber"
                    type="number"
                    placeholder="تعداد مقصد"
                  ></b-form-input>
                </div>
                <div class="form-group col-6">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="compute()"
                  >
                    محاسبه
                  </button>
                </div>
                <div v-if="result !== null" class="form-group col-6">
                  <div class="badge badge-success p-3 font-size-lg">
                    <span dir="ltr">
                      {{ numberFormat(result / 10) }}
                    </span>
                    <span class="p-1">تومان</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
      <b-tab no-body title="خدمات ویژه" class="mt-2">
        <div class="card card-custom gutter-b">
          <div class="card-body">
            <div class="container">
              <div class="row mt-5">
                <div class="form-group col-12">
                  <SpecialSevices></SpecialSevices>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-tab>
    </b-tabs>
    <div
      v-if="prices && prices['live_base'] && prices['live_destination']"
      class="card card-custom gutter-b"
    >
      <div class="card-header">
        <div class="card-title">
          <h3 class="card-label">مبنای محاسبه</h3>
        </div>
      </div>
      <div class="card-body">
        <BasicCalculation :prices="prices"></BasicCalculation>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { mapGetters } from "vuex";
import SpecialSevices from "../content/widgets/list/SpecialSevices.vue";
import BasicCalculation from "./BasicCalculation.vue";

export default {
  name: "calculator",
  data() {
    return {
      time: "",
      destinationNumber: "",
      space: "",
      result: null,
      resultCloudly: null
    };
  },
  components: {
    SpecialSevices,
    BasicCalculation
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "ماشین حساب", route: { name: "calculator-index" } }
    ]);

    this.$store.dispatch(SET_ACTIONS, {});
  },
  computed: {
    ...mapGetters(["prices"])
  },
  methods: {
    compute() {
      let h = new Date().getHours();
      this.result =
        this.destinationNumber < 4
          ? this.time * this.prices["live_base"][h]
          : this.time * this.prices["live_base"][h] +
            this.time *
              this.prices["live_destination"][h] *
              (this.destinationNumber - 3);
    },
    computeCloudy() {
      this.resultCloudly = this.space * this.prices["storage"];
    }
  }
};
</script>
